module.exports = __webpack_public_path__ + "img/arrow_left_square.63422b4a.svg";